import React, { useState, Component } from "react";
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Key from "../../components/Key"
import loadableVisibility from "react-loadable-visibility/loadable-components";
//const AllChamps = loadable(() => import('../components/AllChamps'))
import Loader from "react-loader-spinner";


const AllChamps = loadableVisibility(() => import("../../components/AllChamps"), {
  //fallback: <Loader type="MutatingDots" color="#e8c817" secondaryColor="#65DBEC" height={100} width={100} />
  fallback: <div className="notAnimatedLoading">Loading...</div>
});

/* const AllChamps = loadableVisibility(() => import("src/components/AllChamps"), {
    fallback: <div id="loading" class="loading">Loading...</div>
  }); */

class AllChampsPage extends React.PureComponent {
    render() {
        return ( <Layout>
            <SEO title="Chofly Elite | Raid Shadow Legends: Tier List" keywords={['Raid Shadow Legends', 'All Champs', 'Raid Champs Roster', 'Raid Champ Roster', 'Raid Roster',  'My Heroes Roster', 'Raid Heroes Roster', 'Raid Hero Roster', 'Champion', 'RaidChamps.com', 'Raid Champs', 'Champs', 'Quick Search', 'Champion Quick Search', 'Champion Filters', 'Filter Search', 'Search Filters', 'Raid Champion Filters', 'Raid Champion Search', 'Raid Champion Site with Pictures', 'Raid Champion Site with Images', 'Raid Champion Site with Champ Portraits', 'Champ Portrait Images', 'Champ Portraits', 'RSL', 'Raid', 'Raid Shadow Legends', 'Raid Champion Tier Ratings', 'HellHades Tier Ratings', 'ChoseN Tier Ratings', 'Chofly Elite Tier Ratings', 'Ayumilove Tier Ratings', 'Raid Ability Filters', 'Raid Resources', 'Raid Links', 'Raid Guides', 'Raid Spreadsheets', 'Raid Calculators', 'Raid Tools', 'Raid Tricks', 'YouTube Content Creator Websites', 'Raid YouTube Channels', 'Raid Video Guides', 'Raid Content Creators', 'Raid Video Guide', 'Raid Content Creator', 'Raid Champ Ability Filters', 'Raid Debuffs', 'Raid Buffs', 'Raid Instant Abilities', 'Raid Passive Abilities', 'Raid Auras', 'Raid Factions', 'Raid Rarity', 'Raid Champ Food Indicator', 'Champ Roles']} />

                <div className="ChampItemsDisplay-page page">
                    <div className="h1-container">
                        <h1 className="text-center">Raid Shadow Legends: Tier List</h1>
                        {/* <p className="swapAllChampsPages"><a className="btn" href="/advanced" title="Click here to use the Algolia version of this page that has more advanced filtering options and saves your selections to the URL for sharing your results with others.">Switch to Advanced Filters page with Query Params</a></p> */}
                    </div>
                    <div className="center AllChamps-wrap">                        
                        <AllChamps/>
                    </div>
                    <Key />
                </div>
            </Layout>
        )
    }
}
export default AllChampsPage
